import { createSlice } from '@reduxjs/toolkit';
import { fetchDeviceTypeMap, fetchSystemTypeMap } from '../thunks';

const integrationSlice = createSlice({
  name: 'integration',
  initialState: {
    fetching: true,
    // Tracks whether the initial historical device data snapshot has been loaded
    initialHistoryLoaded: false, // Track if initial historical data snapshot has been loaded
    visibleDeviceTypes: {
      Stage: true,
      'Manual Road Closure': true,
      'Technology Bridge_Flashing Lights': true,
      'Technology Bridge_Siren/Giant Voice': true,
      'Overwatch VMS': true,
      'Monitoring Station': true,
      'Buoy Conditions': true,
    },
    deviceTypeMap: {},
    systemTypeMap: {},
    error: null,
  },
  reducers: {
    setIntegrationSnapshot: (state, action) => {
      const snapshot = action.payload || {}; // Fallback to empty object if payload is undefined

      // Update only the fields present in the snapshot/payload
      if ('fetching' in snapshot) {
        state.fetching = snapshot.fetching ?? state.fetching;
      }

      if ('initialHistoryLoaded' in snapshot) {
        state.initialHistoryLoaded = snapshot.initialHistoryLoaded ?? state.initialHistoryLoaded;
      }

      if ('deviceTypeMap' in snapshot) {
        state.deviceTypeMap = snapshot.deviceTypeMap;
      }

      if ('systemTypeMap' in snapshot) {
        state.systemTypeMap = snapshot.systemTypeMap;
      }
    },
    setVisibleDeviceTypes: (state, action) => {
      state.visibleDeviceTypes = action.payload;
    },
    setFetching: (state, action) => {
      state.fetching = action.payload;
    },
    resetInitialHistoryLoaded: (state) => {
      // Reset initial history loaded flag when user logs out or data needs to be reloaded
      state.initialHistoryLoaded = false;
    },
  },
  extraReducers: (builder) => {
    // Handle async thunks states (pending, fulfilled, rejected)
    builder
      .addCase(fetchDeviceTypeMap.pending, (state) => {
        state.fetching = true;
        state.error = null;
      })
      .addCase(fetchDeviceTypeMap.fulfilled, (state, action) => {
        state.deviceTypeMap = action.payload;
        state.fetching = false;
      })
      .addCase(fetchDeviceTypeMap.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload || action.error?.message || null;
      })
      .addCase(fetchSystemTypeMap.pending, (state) => {
        state.fetching = true;
        state.error = null;
      })
      .addCase(fetchSystemTypeMap.fulfilled, (state, action) => {
        const filteredPayload = Array.isArray(action.payload)
          ? action.payload.filter((system) => system.system_type !== 'TEST SYSTEM')
          : [];
        state.systemTypeMap = filteredPayload;
        state.fetching = false;
      })
      .addCase(fetchSystemTypeMap.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload || action.error?.message || null;
      });
  },
});

export const {
  setFetching,
  setIntegrationSnapshot,
  setVisibleDeviceTypes,
  resetInitialHistoryLoaded,
} = integrationSlice.actions;

export default integrationSlice.reducer;
